import styled from "@emotion/styled";
import { ThemeMode } from "../../../util/theme";
import { formInputTheme } from "./formInputTheme";

export const StyledInput = styled("input")<{
    isHovered: boolean;
    themeMode: ThemeMode;
    variant: "box" | "underline";
}>`
    font-family: inherit;
    font-size: ${({ themeMode, variant }) => formInputTheme.fontSize[variant](themeMode)};
    line-height: ${({ themeMode }) => formInputTheme.lineHeight(themeMode)}px;
    font-weight: ${({ themeMode }) => formInputTheme.fontWeight(themeMode)};

    box-sizing: border-box;
    margin: 0;
    padding: 0 ${({ themeMode }) => formInputTheme.padding.left.rest(themeMode)};
    width: 100%;
    outline: none;

    color: ${({ themeMode }) => formInputTheme.textColor.rest(themeMode)};
    background-color: transparent;
    &[aria-disabled="true"] {
        color: ${({ themeMode }) => formInputTheme.textColor.readonly(themeMode)};
    }
    &::placeholder {
        color: ${({ themeMode }) => formInputTheme.placeholderColor.rest(themeMode)};
    }
    ${({ isHovered, themeMode }) =>
        isHovered
            ? `&::placeholder {
                color: ${formInputTheme.placeholderColor.hover(themeMode)};
            }`
            : ""}

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    border-style: none;
    // Use the outer component's radius.
    border-radius: inherit;
`;
